import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

const faqs = [
  {
    question: 'Welche Angaben sollte ich bereithalten?',
    answer: 'Adresse, Terminwunsch, Betonmenge, Einbringstelle, Zufahrt, Pumpstrecke und eine Kontaktperson vor Ort.',
  },
  {
    question: 'Kann ich Betonpumpe und Beton gemeinsam anfragen?',
    answer: 'Ja. Genau dafür ist die Seite aufgebaut: Transport, Betonverkauf und Pumpe können gemeinsam geplant werden.',
  },
  {
    question: 'Ist eine schnelle telefonische Abstimmung möglich?',
    answer: 'Ja. Für dringende Projekte ist der direkte Anruf meist der beste Startpunkt.',
  },
  {
    question: 'In welchem Gebiet ist MH-BETON im Einsatz?',
    answer: 'Wir arbeiten in Wien, Wien Umgebung und Niederösterreich.',
  },
];

function FaqSection() {
  return (
    <section className="py-12 sm:py-16 md:py-28">
      <div className="container-site mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="FAQ"
            title="Was vor der Anfrage wichtig ist."
            compact
          />
        </Reveal>

        <div className="grid gap-3 mt-8">
          {faqs.map((faq, index) => (
            <Reveal key={index} delay={index * 75}>
              <details className="group rounded-card border border-ink/10 bg-white/90 shadow-card p-5 transition-all hover:-translate-y-0.5 hover:border-signal/40 hover:shadow-[0_18px_42px_rgba(13,37,46,0.12)]">
                <summary className="relative flex items-center min-h-11 cursor-pointer pr-8 font-extrabold list-none transition-colors hover:text-signal-dark">
                  {faq.question}
                  <span className="absolute right-1 top-1/2 -translate-y-1/2 w-2.5 h-2.5 border-r-2 border-b-2 border-signal-dark rotate-45 transition-transform group-open:rotate-[225deg] group-open:top-[calc(50%-2px)]" aria-hidden="true" />
                </summary>
                <p className="mt-3 text-ink-soft text-sm sm:text-base leading-relaxed">{faq.answer}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
